module.exports = __webpack_public_path__ + "img/menu.aafda0f4.svg";